import React from "react";
import Popupz from "../../atoms/Popupz";
import Buttonz from "../../atoms/Buttonz";
import SvgIcn from "../../../data/IconCompo";
import Inputz from "../../atoms/Inputz";


function PasswordResetSuccessPopup({ onClose }) {
  return (

<Popupz
title="Password Reset Complete"
text={
  <>
    Your password has been successfully changed.  
    You can now log in with your new password.
    
  </>
}
onClose={onClose}
popupId="close"
iconIllus="chara00"

>
{/* <Buttonz
            iconR="close"
            hoverR="close"
            label="Close"
            onClick={onClose}
            className={"btn-primary"}
          /> */}
</Popupz> 

  );
}

export default PasswordResetSuccessPopup;


